import Vue from 'vue';

const state = {
  searchState: {},
};

const mutations = {
  SET_SEARCH_STATE(stateObj, payload) {
    const { searchType, ...fields } = payload;
    if (!searchType) return;
    Vue.set(stateObj.searchState, searchType, { ...fields });
  },
  RESET_SEARCH_STATE(stateObj, searchType) {
    if (!searchType) return;
    Vue.delete(stateObj.searchState, searchType);
  },
  RESET_ALL_SEARCH_STATE(stateObj) {
    Vue.set(stateObj, 'searchState', {});
  },
};

const actions = {
  setSearchState({ commit }, payload) {
    commit('SET_SEARCH_STATE', payload);
  },
  resetSearchState({ commit }, searchType) {
    commit('RESET_SEARCH_STATE', searchType);
  },
  resetAllSearchState({ commit }) {
    commit('RESET_ALL_SEARCH_STATE');
  },
};

const getters = {
  getSearchByType: s => type => s.searchState[type] || {},
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
